import { Col, EditButton, List, Row, Space, Table, TextField, useTable } from '@pankod/refine-antd';
import { IResourceComponentsProps, useTranslate } from '@pankod/refine-core';
import React from 'react';
import { IAds, IAdsResponse } from 'types/ads.interface';

export const AdsList: React.FC<IResourceComponentsProps> = () => {
    const t = useTranslate();
    const { tableProps }: any = useTable<IAdsResponse>({
        resource: 'ads',
        initialPageSize: 100,
    });

    return (
        <List>
            <Row style={{ display: 'block' }}>
                <Col>
                    <Table
                        {...tableProps}
                        pagination={{
                            ...tableProps?.pagination,
                            showSizeChanger: true,
                        }}
                        rowKey='id'
                    >
                        <Table.Column
                            dataIndex='startTime'
                            key='startTime'
                            title='Start time'
                            render={(value) => <TextField value={value ? new Date(value).toLocaleString() : ''} />}
                        />
                        <Table.Column dataIndex='endTime' key='endTime' title='End time' render={(value) => <TextField value={value ? new Date(value).toLocaleString() : ''} />} />
                        <Table.Column dataIndex='user' key='user' title='Contributor' render={(value) => <TextField value={value.username} />} />
                        <Table.Column
                            dataIndex='link'
                            key='link'
                            title='Link'
                            render={(value) => (
                                <a href={value} target='_blank' rel='noreferrer'>
                                    <TextField value={value} />
                                </a>
                            )}
                        />
                        <Table.Column
                            dataIndex='adsImageUrl'
                            key='adsImageUrl'
                            title='Image url'
                            render={(value) => (
                                <a href={value} target='_blank' rel='noreferrer'>
                                    <TextField value={value} />
                                </a>
                            )}
                        />
                        <Table.Column dataIndex='status' key='status' title='Status' render={(value) => <TextField value={value} />} />
                        <Table.Column dataIndex='adClickCount' key='adClickCount' title=' Clicks' render={(value) => <TextField value={value || 0} />} />
                        <Table.Column<IAds>
                            title={t('table.actions')}
                            dataIndex='actions'
                            render={(_, record) => (
                                <Space>
                                    <EditButton hideText size='small' recordItemId={record._id} />
                                    {/* <DeleteButton hideText size='small' recordItemId={record._id} /> */}
                                </Space>
                            )}
                        />
                    </Table>
                </Col>
            </Row>
        </List>
    );
};
